"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.konfektionierungJsonMock = void 0;
const KonfektionierungTyp_1 = require("./KonfektionierungTyp");
exports.konfektionierungJsonMock = {
    EntityId: '1508954445171_947859',
    Typ: KonfektionierungTyp_1.KonfektionierungTyp.auftrommelnRatePerMeter,
    ArtNrExists: true,
    ArtNrGenerated: 'KONFEKTIONIERUNG',
    BasePriceVK: { Countries: { DE: { EUR: 44.025940000000006 } } },
};
//# sourceMappingURL=KonfektionierungJsonMock.js.map